import React from 'react';
import styled from 'styled-components';

import TransLink from '@common/TransLink';
import { Button } from '@components/global';

import { ReactComponent as ArrowRightIcon } from '@static/icons/arrow-right.svg';
import { ReactComponent as CartIcon } from '@static/icons/cart.svg';

const ProductCard = ({
  title,
  desc,
  subtitle,
  points,
  knowLink,
  onAddClick,
  ...other
}) => (
  <Card {...other}>
    <Title>{title}</Title>
    <Desc>{desc}</Desc>
    <Subtitle>{subtitle}</Subtitle>
    <Points>
      {points.map((point, i) => (
        <li key={i}>{point}</li>
      ))}
    </Points>
    <Buttons>
      <Button as={TransLink} secondary to={knowLink}>
        Know More
        <ArrowRightIcon />
      </Button>
      <Button onClick={onAddClick} disabled>
        Add to cart <CartIcon />
      </Button>
    </Buttons>
    <Info>Available for in-salon technical use and retail</Info>
  </Card>
);

const Card = styled.div`
  background: ${props => props.theme.color.blue[3].light};
  border-radius: 2px;
  padding: 2.75rem 2.5rem;
  color: ${props => props.theme.color.blue.card};
  box-shadow: 0px 3.58073px 44.7591px rgba(88, 107, 124, 0.3);
  position: relative;

  @media (max-width: ${props => props.theme.screen.sm}) {
    padding: 2rem;
  }
`;

const Title = styled.h2`
  color: ${props => props.theme.color.blue.card};
  line-height: 1;
  padding-left: 1rem;
  position: relative;
  text-align: left;
  font-weight: normal;
  line-height: 108%;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    width: 4px;
    height: 100%;
    background-color: ${props => props.theme.color.blue[1].dark};
    opacity: 0.6;

    @media (max-width: ${props => props.theme.screen.sm}) {
      width: 2px;
    }
  }
`;

const Desc = styled.p`
  ${props => props.theme.font_size.large};
  line-height: 125%;
  color: ${props => props.theme.color.blue[2].dark};
  margin-top: 3rem;

  @media (max-width: ${props => props.theme.screen.md}) {
    ${props => props.theme.font_size.regular};
    margin-top: 2rem;
  }
`;

const Subtitle = styled.h4`
  color: ${props => props.theme.color.blue.card};
  margin-top: 3.5rem;
  text-align: left;
  ${props => props.theme.font_size.xlarge};

  @media (max-width: ${props => props.theme.screen.md}) {
    ${props => props.theme.font_size.large};
    margin-top: 3rem;
  }
`;

const Points = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  margin-top: 1rem;
  margin-bottom: 3.5rem;

  li {
    ${props => props.theme.font_size.regular};
    padding: 0.25rem 0;

    &:not(:last-child) {
      border-bottom: 1px solid ${props => props.theme.color.blue[2].light};
    }
  }

  @media (max-width: ${props => props.theme.screen.md}) {
    margin-top: 0.75rem;
    margin-bottom: 3rem;

    li {
      ${props => props.theme.font_size.smaller};
    }
  }
`;

const Info = styled.p`
  ${props => props.theme.font_size.small};
  color: ${props => props.theme.color.blue[1].dark};
  text-align: center;
  margin-top: 1rem;
  margin-bottom: -1rem;

  @media (max-width: ${props => props.theme.screen.md}) {
    ${props => props.theme.font_size.xsmall};
  }
`;

const Buttons = styled.div`
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: ${props => props.theme.screen.sm}) {
    grid-template-columns: 1fr;
  }
`;

export default ProductCard;
